import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ApiSitesBuilderService } from '../services/api-sites-builder.service';
import { catchError, map, of } from 'rxjs';

export const siteRedirectGuard: CanActivateFn = (route, state) => {
  const siteTitle = route.params['site'];
  const apiSitesBuilderService = inject(ApiSitesBuilderService);

  return apiSitesBuilderService.getRedirectUrl$(siteTitle).pipe(
    map((redirectUrl) => {
      if (!redirectUrl) return true;
      window.location.replace(redirectUrl);
      return false;
    }),
    catchError((error) => {
      console.error('Error in Site Redirect Guard: ', error);
      return of(true);
    })
  );

};
